/*
 * Rótulos do switch nos seis idiomas, sem react-intl: o controle é montado por página do
 * legado, fora do SPA, e puxar o `LangService` arrastaria dezenas de namespaces para o bundle.
 * As chaves são os códigos de `$lang`, e o rótulo nomeia o modo CORRENTE, não a ação do clique.
 */

export type TThemeSwitchLang = 'pt_br' | 'en_us' | 'es' | 'fr' | 'it' | 'de';

export interface IThemeSwitchLabels {
    /** Rótulo exibido enquanto o tema corrente é o escuro. */
    dark: string;
    /** Rótulo exibido enquanto o tema corrente é o claro. */
    light: string;
    /** Texto acessível do controle, lido por leitor de tela. */
    action: string;
}

export const DEFAULT_LANG: TThemeSwitchLang = 'pt_br';

const messages: Record<TThemeSwitchLang, IThemeSwitchLabels> = {
    pt_br: { dark: 'Modo escuro', light: 'Modo claro', action: 'Alternar tema' },
    en_us: { dark: 'dark mode', light: 'light mode', action: 'Toggle theme' },
    es: { dark: 'Modo oscuro', light: 'Modo luminoso', action: 'Cambiar tema' },
    fr: { dark: 'Mode sombre', light: 'Mode clair', action: 'Changer de thème' },
    it: { dark: 'Modalità scura', light: 'Modalità chiara', action: 'Cambia tema' },
    de: { dark: 'Dunkelmodus', light: 'Lichtmodus', action: 'Design wechseln' }
};

/**
 * Resolve os rótulos do idioma pedido, caindo em pt-BR: o `data-lang` é dado de HTML e pode
 * chegar vazio.
 */
export const resolveLabels = (lang?: string): IThemeSwitchLabels =>
    messages[(lang || '') as TThemeSwitchLang] || messages[DEFAULT_LANG];

export default messages;
